var map = {
	"./template.bet575": 1633,
	"./template.bet575.tsx": 1633,
	"./template.bet777": 1634,
	"./template.bet777.tsx": 1634,
	"./template.betprofessor": 1635,
	"./template.betprofessor.tsx": 1635,
	"./template.betroyale": 1636,
	"./template.betroyale.tsx": 1636,
	"./template.buffalobet": 1637,
	"./template.buffalobet.tsx": 1637,
	"./template.chromabet": 1638,
	"./template.chromabet.tsx": 1638,
	"./template.default": 675,
	"./template.default.tsx": 675,
	"./template.epicodds": 1639,
	"./template.epicodds.tsx": 1639,
	"./template.fiestabet": 1640,
	"./template.fiestabet.tsx": 1640,
	"./template.gigabet": 1641,
	"./template.gigabet.tsx": 1641,
	"./template.goldenbet888": 1642,
	"./template.goldenbet888.tsx": 1642,
	"./template.goldenrush": 1643,
	"./template.goldenrush.tsx": 1643,
	"./template.hyperbet": 1644,
	"./template.hyperbet.tsx": 1644,
	"./template.juicybet": 1645,
	"./template.juicybet.tsx": 1645,
	"./template.junglebet": 1646,
	"./template.junglebet.tsx": 1646,
	"./template.magnumbet": 1647,
	"./template.magnumbet.tsx": 1647,
	"./template.oldgill": 1648,
	"./template.oldgill.tsx": 1648,
	"./template.puntcity": 1649,
	"./template.puntcity.tsx": 1649,
	"./template.puntgenie": 1650,
	"./template.puntgenie.tsx": 1650,
	"./template.pyramidbet": 1651,
	"./template.pyramidbet.tsx": 1651,
	"./template.questbet": 1652,
	"./template.questbet.tsx": 1652,
	"./template.slambet": 1653,
	"./template.slambet.tsx": 1653,
	"./template.sterlingparker": 1654,
	"./template.sterlingparker.tsx": 1654,
	"./template.sugarcastle": 1655,
	"./template.sugarcastle.tsx": 1655,
	"./template.templebet": 1656,
	"./template.templebet.tsx": 1656,
	"./template.titanbet": 1657,
	"./template.titanbet.tsx": 1657,
	"./template.ts": 988,
	"./template.vikingbet": 1658,
	"./template.vikingbet.tsx": 1658,
	"./template.volcanobet": 1659,
	"./template.volcanobet.tsx": 1659,
	"./template.wellbet": 1660,
	"./template.wellbet.tsx": 1660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2469;